export default "__VITE_ASSET__DY92$58R__"